// MODES
export const MODES = {
  LIGHT: "light",
  DARK: "dark",
  SYSTEM: "system",
};
export const VALID_MODES = new Set([MODES.LIGHT, MODES.DARK, MODES.SYSTEM]);

// Fonts
export const TITLE_FONT_WEIGHT = 550;
export const DEFAULT_FONT_FAMILY = '"Inter", "Arial", sans-serif';

// Border Radius
export const COLOUR_RADIUS = "8px";
export const BORDER_RADIUS = "12px";
export const BUTTON_BORDER_RADIUS = "30px";
export const BUTTON_MIN_WIDTH = "150px";
export const BUTTON_MIN_HEIGHT = "2.5rem";
